import { Col, Row } from "react-bootstrap";
import React, { Fragment } from "react";
import SForm, {
  Block,
  CurrencyField,
  DatePicker,
  Select,
  SelectCategory,
  SelectClient,
  SelectCollaborator,
  SelectTagArticle,
  TextArea,
  TextField,
  Toggle
} from "./SForm";
import { isArray, isEqual, reduce } from "lodash";

import PropTypes from "prop-types";

const flattenSchema = schema =>
  reduce(
    schema,
    (result, card) => {
      card.fields.map(field => (result[field.name] = field));
      return result;
    },
    {}
  );

const controlForField = {
  string: TextField,
  text: TextArea,
  date: DatePicker,
  select: Select,
  selectCollaborator: SelectCollaborator,
  selectClient: SelectClient,
  selectCategory: SelectCategory,
  selectTagArticle: SelectTagArticle,
  currency: CurrencyField,
  toggle: Toggle,
  div: Block
};

class FormBuilder extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.initialState(props);
    this.renderInput = this.renderInput.bind(this);
    this.onChange = this.onChange.bind(this);
    // this.renderCard = this.renderCard.bind(this);
    this.isValid = this.isValid.bind(this);
  }

  initialState(props) {
    return {
      object: props.object,
      flattenSchema: flattenSchema(props.schema),
      errors: {}
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState(this.initialState(nextProps));
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !isEqual(this.props, nextProps) || !isEqual(this.state, nextState);
  }

  onChange(e) {
    const { name, value } = e.target;

    const newObject = {
      ...this.state.object,
      [name]: value
    };
    let newErrors = {};
    if (this.state.flattenSchema[name].validation)
      newErrors = {
        ...this.state.errors,
        [name]: this.state.flattenSchema[name].validation(value)
      };
    this.setState({ object: newObject, errors: newErrors });
  }

  // this function "translate" data for onChange() if using CurrencyField in the form.
  updateFormValue(key, value) {
    this.onChange({ target: { name: key, value: value } });
  }

  onSubmit = async form => {
    await this.validateForm(this.state.flattenSchema);
    this.props.onSubmit(this.state.object);
  };

  validateForm(object) {
    Object.keys(object).map(key => this.isValidated(key));
  }

  isValidated(field) {
    let newErrors = {};
    let value = this.state.object[field];
    if (this.state.flattenSchema[field].validation)
      newErrors = {
        [field]: this.state.flattenSchema[field].validation(value)
      };
    this.setState(prevState => ({
      errors: { ...prevState.errors, ...newErrors }
    }));
  }

  isValid() {
    return Object.keys(this.state.errors).length === 0;
  }

  renderInput(props, index) {
    const {
      intl,
      intl: { formatMessage }
    } = this.props;
    const { companyId } = this.props;
    const width = Object.assign({}, { xs: 12 }, props.width || {});

    return (
      <Col {...width} key={index}>
        {props.type === "div" ? (
          <Block {...props} />
        ) : (
          <SForm.Input
            {...props}
            companyId={companyId}
            currency={this.props.currency}
            intl={intl}
            label={
              props.label
                ? formatMessage({ id: props.label })
                : "[Missing Label]"
            }
            control={controlForField[props.type]}
            onChange={this.onChange}
            update={this.updateFormValue}
            value={(this.state.object && this.state.object[props.name]) || null}
            labels={props.labels}
            error={
              this.state.errors && this.state.errors[props.name]
                ? formatMessage({ id: this.state.errors[props.name] })
                : null
            }
          />
        )}
      </Col>
    );
  }

  renderGroup(fields, index) {
    return (
      <Row key={`form-group-${index}`}>
        {isArray(fields)
          ? fields.map((field, i) =>
              this.renderInput(field, `group-${index}-${i}`)
            )
          : this.renderInput(fields, `group-${index}`)}
      </Row>
    );
  }

  // renderCard(card, index) {
  //   return (
  //     <Col {...card.width} key={`card-${index}`}>
  //       <Card></Card>
  //     </Col>
  //   );
  // }

  render() {
    const { schema } = this.props;
    return (
      <Fragment>
        {schema.map((card, i) =>
          card.fields.map((field, i) => this.renderGroup(field, i))
        )}
        {this.props.children}
      </Fragment>
    );
  }
}

FormBuilder.propTypes = {
  intl: PropTypes.object.isRequired
};

export default FormBuilder;
